var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    fillRule: "evenodd",
    d: "M5.59 4.41a.833.833 0 0 0-1.18 1.18l.246.242-1.079 1.079a.833.833 0 0 0 1.179 1.178l1.085-1.085.491.485-1.088 1.088a.833.833 0 1 0 1.179 1.179L7.517 8.66l2.97 2.937a3.333 3.333 0 1 0 1.196-1.161L5.588 4.41Zm6.077 8.923a1.667 1.667 0 1 1 3.333 0 1.667 1.667 0 0 1-3.333 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgKey;